'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002419 from "./presto.-Login-Page-View$$anon$19.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$18() {
  this.b6a = null;
  this.b62 = null;
  this.b63 = false;
  this.b6b = null;
  this.b6c = false;
  this.b6f = null;
  this.b68 = null;
  this.b69 = false;
  this.b64 = null;
  this.b65 = false;
  this.b66 = null;
  this.b67 = false;
  this.b6d = false;
  this.b6e = false;
  this.b6a = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b6f = "MorbidUserDetails";
}
export { $c_Lpresto_LoginPageView$$anon$18 as $c_Lpresto_LoginPageView$$anon$18 };
$p = $c_Lpresto_LoginPageView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$18;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$18() {
}
export { $h_Lpresto_LoginPageView$$anon$18 as $h_Lpresto_LoginPageView$$anon$18 };
$h_Lpresto_LoginPageView$$anon$18.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.b6a;
});
$p.L = (function() {
  if ((!this.b63)) {
    this.b62 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b63 = true;
  }
  return this.b62;
});
$p.O = (function() {
  if ((!this.b6c)) {
    this.b6b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b6c = true;
  }
  return this.b6b;
});
$p.E = (function() {
  return this.b6f;
});
$p.t = (function() {
  if ((!this.b69)) {
    this.b68 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b69 = true;
  }
  return this.b68;
});
$p.M = (function() {
  if ((!this.b65)) {
    this.b64 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b65 = true;
  }
  return this.b64;
});
$p.Q = (function() {
  if ((!this.b67)) {
    this.b66 = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002419.$c_Lpresto_LoginPageView$$anon$19();
    this.b67 = true;
  }
  return this.b66;
});
$p.w = (function() {
  if ((!this.b6e)) {
    this.b6d = false;
    this.b6e = true;
  }
  return this.b6d;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee126) => ((p) => \u03b4scrutinee126.GD(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_LoginPageView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$18, "presto.LoginPageView$$anon$18", ({
  Ma: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$18 as $d_Lpresto_LoginPageView$$anon$18 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$18.js.map
